import { getReferenceId, getReferenceType } from '@quromedical/fhir-common';
import type * as fhir from 'fhir/r4';

import { type ReferenceView, ReferenceViewSchema } from './models';

export const mapReferenceToViewModel = (
  ref?: fhir.Reference,
): ReferenceView | undefined => {
  if (!ref) {
    return undefined;
  }

  const type = getReferenceType(ref);

  const d = {
    id: getReferenceId(ref),
    type,
    name: ref.display || '',
  };

  const parsed = ReferenceViewSchema.safeParse(d);

  // Question: Should we throw an error here?
  if (!parsed.success) {
    return undefined;
  }

  return parsed.data;
};
